module.exports = __webpack_public_path__ + "static/media/trash-icon.0175b259.svg";